module.exports = __webpack_public_path__ + "static/img/3.cbdbb83.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/6/1/6/eng/3.png
// module id = gEY4
// module chunks = 0